import { C } from "../lib/colors.js";
import { fmtShortDate } from "../lib/formatDates.js";

const LABEL = {
  fontSize: 12,
  color: C.white,
  fontWeight: 600,
  marginBottom: 5,
};

/** The Question panel's foot: when the forecast was first made and when it resolves. */
export default function QuestionDates({ createdAt, resolutionDate }) {
  return (
    <div
      data-question-dates=""
      style={{ gridColumn: "1 / -1", display: "flex", flexWrap: "wrap", columnGap: 32, rowGap: 12 }}
    >
      <div>
        <div style={LABEL}>First forecast</div>
        <div data-question-date="forecasted" style={{ color: C.grayL }}>
          {fmtShortDate(createdAt)}
        </div>
      </div>
      <div>
        <div style={LABEL}>Resolves</div>
        <div data-question-date="resolution" style={{ color: C.grayL }}>
          {fmtShortDate(resolutionDate, { calendarDay: true })}
        </div>
      </div>
    </div>
  );
}
